import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { BaseUserDetailsDto } from "../../types/dtos/generic";
import { useAuth } from "react-oidc-context";
import collabDocApi from "../../api/forms/collabDocApi";
import { useState } from "react";
import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons";

interface SendReminderToManagerBannerProps {
  managerRoleUser: BaseUserDetailsDto;
  journeyReference: string;
}

export const SendReminderToManagerBanner = ({
  managerRoleUser,
  journeyReference,
}: SendReminderToManagerBannerProps) => {
  // Auth/API
  const auth = useAuth();
  const apiCollabDocs = new collabDocApi(auth.user?.access_token);
  const managerRoleName = managerRoleUser.firstName;

  // State
  const [hasReminderBeenSent, setHasReminderBeenSent] =
    useState<boolean>(false);
  const [awaitingApiResult, setAwaitingApiResult] = useState<boolean>(false);

  // Events
  const handleSendReminderClick = () => {
    setAwaitingApiResult(true);
    apiCollabDocs.sendReminderToManagerRole(
      managerRoleUser.userId,
      journeyReference,
      (response) => {
        if (response) {
          console.log("Reminder sent to manager role");
          setHasReminderBeenSent(true);
          setAwaitingApiResult(false);
        } else {
          console.error("Error sending reminder to manager role");
        }
      },
      (error) => {
        console.error("Error sending reminder to manager role", error);
      }
    );
  };

  return (
    <>
      <div className="bg-blue-100 py-1 px-4 mb-2 text-blue-700 text-sm rounded-sm border-l-2 border-l-blue-800">
        <div className="text-blue-800">
          <div className="fa-layers fa-fw mr-0.5">
            <FontAwesomeIcon icon={faInfoCircle} />
          </div>
          <span>
            {t("CollabDoc.Alert.EmpPrepSendReminder.ManagerNeedsToFinishPrep", {
              managerRoleName: managerRoleName,
            })}{" "}
          </span>
          <span>
            {/* Available to send */}
            {!awaitingApiResult && !hasReminderBeenSent && (
              <button
                className="underline hover:font-semibold"
                onClick={handleSendReminderClick}
              >
                {t("CollabDoc.Alert.EmpPrepSendReminder.SendManagerReminder", {
                  managerRoleName: managerRoleName,
                })}
              </button>
            )}
            {/* Sending reminder */}
            {awaitingApiResult && !hasReminderBeenSent && (
              <span>
                {t("CollabDoc.Alert.EmpPrepSendReminder.SendingReminder")}...
                <FontAwesomeIcon
                  className="ml-1"
                  icon={faSpinnerThird}
                  size="1x"
                  spin
                />
              </span>
            )}
            {/* Reminder has been sent */}
            {hasReminderBeenSent && (
              <span className="underline">
                {t("CollabDoc.Alert.EmpPrepSendReminder.ReminderWasSent", {
                  managerRoleName: managerRoleName,
                })}
              </span>
            )}
          </span>
        </div>
      </div>
    </>
  );
};

export default SendReminderToManagerBanner;
